import { BufferTrackerReact as BufferTracker } from '@buffer-mono/tracking-plan'

import type { PlanSelectorChannelQuantityClickedTrackingArguments } from './PlanSelectorTrackingTypes'

import { hasPaymentDetails, getOrganization } from '../../common/utils/user'

import { shouldPerformTrackingEvent } from '../utils'

export default function trackPlanSelectorChannelQuantityClicked({
  payload,
  user,
}: PlanSelectorChannelQuantityClickedTrackingArguments): void {
  const canPerformTrackingEvent = shouldPerformTrackingEvent({
    user,
  })

  if (!canPerformTrackingEvent) {
    return
  }

  const organization = getOrganization(user)
  const commonTrackingProperties =
    organization?.commonTrackingProperties || null
  const eventData = {
    organizationId: organization?.id || null,
    channelQuantity: payload?.channelQuantity || null,
    ...commonTrackingProperties,
    hasPaymentDetails: hasPaymentDetails(user) || null,
  }

  BufferTracker.planSelectorChannelQuantityClicked(eventData)
}
